export default __webpack_public_path__ + "static/media/bg-pattern-leaf.b8760898.svg";